import { action as apiAction } from 'api/Api'
import { BlockerType } from 'const/blockerType'
import { optimisticDispatch } from 'utils/sagas'
import {
  add
} from '../redux/blockers'

type Payload = {
  name: string;
  type: BlockerType;
  description?: any;
}

const requestAddBlocker = (payload: Payload) => async dispatch => {
  const { name, type, description } = payload

  const optimisticAction = optimisticDispatch(dispatch, add({
    id: `temp-${new Date().getTime()}`,
    type,
    name,
    description,
    position: -1,
    isBusy: true,
  }))

  try {
    await apiAction('AddBlocker', {
      name,
      type,
      rtDescription: description
    })
  } finally {
    optimisticAction.revert()
  }
}

export default requestAddBlocker